import * as React from 'react';
import { SVGProps } from 'react';

const IconFileSchemeSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 2.793 19.207 7H22v10h-9.53a4 4 0 0 1-7.94 0h-2.53V7h8.793L15 2.793ZM10.793 8H3v8h1.53a4 4 0 0 1 7.94 0H21V8h-1.793L15 12.207 10.793 8Zm7.5-.5L15 4.207 11.707 7.5 15 10.793 18.293 7.5Zm-9.793 6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
    />
  </svg>
);
export default IconFileSchemeSizeM;
